(function () {
  var STORAGE_KEY = 'plp_referrer_handle';
  var STORAGE_TS = 'plp_referrer_ts';
  var TTL_MS = 1000 * 60 * 60; // 1 hour

  function setReferrer(handle) {
    try {
      sessionStorage.setItem(STORAGE_KEY, handle);
      sessionStorage.setItem(STORAGE_TS, Date.now());
    } catch (e) {
      // ignore
    }
  }

  function getReferrer() {
    try {
      var ts = parseInt(sessionStorage.getItem(STORAGE_TS), 10) || 0;
      if (Date.now() - ts > TTL_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_TS);
        return null;
      }
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function handleProductLinkClick(e) {
    var el = e.target;
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (!el) return;
    var href = el.getAttribute('href') || '';
    if (!/\/products\//.test(href)) return;

    // If current page is a collection page, capture its handle
    var coll = detectCollectionHandleFromPath(window.location.pathname);
    if (coll) setReferrer(coll);
  }

  function detectCollectionHandleFromPath(path) {
    // match /collections/<handle> or /collections/<handle>/... 
    var m = path.match(/^\/collections\/([^\/\?]+)/i);
    if (m && m[1]) return decodeURIComponent(m[1]);
    return null;
  }

  // On load, if we are on a collection page, save handle
  try {
    var initialHandle = detectCollectionHandleFromPath(window.location.pathname);
    if (initialHandle) setReferrer(initialHandle);
  } catch (e) {}

  // Delegate clicks on document to catch product links inside PLP
  document.addEventListener('click', function (e) {
    try { handleProductLinkClick(e); } catch (err) {}
  }, true);

  // Expose helper for other scripts
  window.PLPReferrer = {
    get: getReferrer,
    set: setReferrer
  };
  // Attach handler for elements that want to open PLP based on stored referrer
  document.addEventListener('DOMContentLoaded', function () {
    var openers = document.querySelectorAll('.js-open-plp');
    if (!openers || !openers.length) return;
    openers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var stored = getReferrer();
        if (stored) {
          window.location.href = '/collections/' + encodeURIComponent(stored);
          return;
        }
        // fallback to href on element
        var href = el.getAttribute('href');
        if (href) window.location.href = href;
      });
    });
  });
})();
